namespace TotalPoll {
    import Service = TotalCore.Common.Service;

    @Service('services.totalpoll')
    export class RepositoryService {
        public resource;

        constructor($resource, prefix, ajaxEndpoint) {
            this.resource = $resource(ajaxEndpoint, {}, {
                activate: {method: 'GET', params: {action: `${prefix}_dashboard_activate`}},
                deactivate: {method: 'GET', params: {action: `${prefix}_dashboard_deactivate`}},
                account: {method: 'GET', params: {action: `${prefix}_dashboard_account`}},
                pollsOverview: {method: 'GET', params: {action: `${prefix}_dashboard_polls_overview`}, isArray: true},
                blogFeed: {method: 'GET', params: {action: `${prefix}_dashboard_blog_feed`}, isArray: true},

            });

            return this;
        }

        getPollsOverview() {
            return this.resource.pollsOverview().$promise;
        }

        postAccount(account) {
            return this.resource.account(account).$promise;
        }

        postActivation(activation) {
            return this.resource.activate(activation).$promise;
        }

        getBlogFeed() {
            return this.resource.blogFeed().$promise;
        }
        postDeactivation(){
            return this.resource.deactivate().$promise;
        }


    }
}
